enum BusinessBranchContentType {
    None,
    Headline,
    ServiceOffered,
    Body,
    LicenseQualification
}

export default BusinessBranchContentType
